import { render, staticRenderFns } from "./autoTemplatList.vue?vue&type=template&id=c2c2dd32&scoped=true&"
import script from "./autoTemplatList.vue?vue&type=script&lang=js&"
export * from "./autoTemplatList.vue?vue&type=script&lang=js&"
import style0 from "./autoTemplatList.vue?vue&type=style&index=0&id=c2c2dd32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c2dd32",
  null
  
)

export default component.exports